import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Pages already rebuilt in the new design by hand. Every other route gets
// body.ocs-theme, which maps their old red, rounded classes onto the new look
// (see "Site theme" in App.css). /special-offer is a promo landing page and
// keeps its own campaign styling.
const HANDBUILT = ["/shop", "/customize", "/quiz", "/special-offer"];

const isHandbuilt = (pathname) =>
	pathname === "/" ||
	HANDBUILT.some((p) => pathname === p || pathname.startsWith(`${p}/`));

export default function ThemeScope() {
	const { pathname } = useLocation();

	useEffect(() => {
		document.body.classList.toggle("ocs-theme", !isHandbuilt(pathname));
	}, [pathname]);

	return null;
}
